/* Mega menu: swap the right-hand image as the pointer moves down the links.

   Built on the theme's own image-link-text blocks rather than new markup, so
   every image stays editable in the customizer. Add one block per link at the
   same menu position, in the same order as the links.

   Only engages where a dropdown has more than one card, so mega menus with a
   single static image are untouched. */
(function () {
  'use strict';

  function wire(item) {
    var group = item.querySelector('.header__nav--group-card');
    if (!group || group.hasAttribute('data-rbp-swap')) return;

    // list items only -- the theme also drops a <style> element in here, and
    // toggling display on that renders its CSS as text in the dropdown
    var cards = Array.prototype.filter.call(group.children, function (el) {
      return el.tagName === 'LI';
    });
    var links = item.querySelectorAll(
      '.header__nav--group-link > .header__nav-links-item--link'
    );
    if (cards.length < 2 || links.length < 2) return;

    group.setAttribute('data-rbp-swap', '');
    item.classList.add('rbp-megamenu-split');

    // A trailing "Shop all ..." link sits at the bottom of the panel and is
    // not one of the shapes, so it is excluded from the image mapping.
    var swapLinks = [];
    Array.prototype.forEach.call(links, function (li) {
      var label = (li.textContent || '').trim();
      if (/^shop all/i.test(label)) {
        li.classList.add('rbp-shop-all');
      } else {
        swapLinks.push(li);
      }
    });
    links = swapLinks;

    function show(i) {
      var n = Math.max(0, Math.min(i, cards.length - 1));
      cards.forEach(function (card, idx) {
        card.classList.toggle('is-active', idx === n);
      });
    }

    show(0);

    links.forEach(function (li, i) {
      li.addEventListener('mouseenter', function () { show(i); });
      // keyboard users get the same behaviour
      li.addEventListener('focusin', function () { show(i); });
    });

    // back to the first image when the pointer leaves the dropdown
    item.addEventListener('mouseleave', function () { show(0); });
  }

  function init() {
    document
      .querySelectorAll('.header__nav-item.megamenu')
      .forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // the header re-renders on section reload in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
